import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import traderaStores from './modules/tradera-stores'
import traderaStoreConnectRequest from './modules/tradera-store-connect-request'
import traderaOrders from './modules/tradera-orders'
import salesItems from './modules/sales-items'

Vue.use(Vuex);

const debug = (process.env.NODE_ENV !== 'production');

export default new Vuex.Store({
    modules: {
        auth,
        traderaStores,
        traderaStoreConnectRequest,
        traderaOrders,
        salesItems
    },
    strict: debug
});
